const getWindow = () => typeof window !== 'undefined' ? window : null;

export const readLocalStorage = (key: string): string | null => {
    try {
        return getWindow()?.localStorage?.getItem(key) ?? null;
    } catch (error) {
        return null;
    }
};

export const writeLocalStorage = (key: string, value: string): void => {
    try {
        getWindow()?.localStorage?.setItem(key, value);
    } catch (error) {
        // Storage can be disabled in private or embedded webviews.
    }
};

export const removeLocalStorage = (key: string): void => {
    try {
        getWindow()?.localStorage?.removeItem(key);
    } catch (error) {
        // Storage can be disabled in private or embedded webviews.
    }
};

export const clearLocalStorage = (): void => {
    try {
        getWindow()?.localStorage?.clear();
    } catch (error) {
        // Storage can be disabled in private or embedded webviews.
    }
};

export const readSessionStorage = (key: string): string | null => {
    try {
        return getWindow()?.sessionStorage?.getItem(key) ?? null;
    } catch (error) {
        return null;
    }
};

export const writeSessionStorage = (key: string, value: string): void => {
    try {
        getWindow()?.sessionStorage?.setItem(key, value);
    } catch (error) {
        // Storage can be disabled in private or embedded webviews.
    }
};

export const removeSessionStorage = (key: string): void => {
    try {
        getWindow()?.sessionStorage?.removeItem(key);
    } catch (error) {
        // Storage can be disabled in private or embedded webviews.
    }
};
